import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NovaLensesWebsite from './NovaLensesWebsite';
import Products from './Products';
import SimpleAdmin from './SimpleAdmin';
import LensInstructions from './LensInstructions';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NovaLensesWebsite />} />
        <Route path="/products" element={<Products />} />
        <Route path="/admin" element={<SimpleAdmin />} />
        <Route path="/instructions" element={<LensInstructions />} />
      </Routes>
    </Router>
  );
}

export default App;